module.exports = __webpack_public_path__ + "components/country-flag/static/fi-4d61f87483bbe2a3965fc6c8469fd0fb.svg";